import { render, staticRenderFns } from "./SideMenuComponent.vue?vue&type=template&id=6cf89942&scoped=true&"
import script from "./SideMenuComponent.vue?vue&type=script&lang=js&"
export * from "./SideMenuComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf89942",
  null
  
)

export default component.exports